export default __webpack_public_path__ + "static/media/pageLeftPolygon.df25b1fb.svg";